import * as CONST from '../ActionTypes';

const initialState = {
  discount: null,
  isSuccess: false,
  isFailure: false,
  errorMessage: '',
};

function payment(state = initialState, action) {
  switch (action.type) {
    // -----------------
    // 決済
    // -----------------
    case CONST.PAYMENT_SUCCESS:
      return {
        ...state,
        isSuccess: true,
        isFailure: false,
      };
    case CONST.PAYMENT_FAILURE:
      return {
        ...state,
        isSuccess: false,
        isFailure: true,
        errorMessage: action.payload,
      };
    // -----------------
    // 決済
    // -----------------
    case CONST.CLEAR_PAYMENT_RESULT:
      return {
        ...state,
        isSuccess: false,
        isFailure: false,
        errorMessage: '',
      };
    case CONST.GET_RULE_DISCOUNT_SUCCESS:
      return {
        ...state,
        discount: action.payload,
      };
    default:
      return state;
  }
}

export default payment;
